import React, { Component, PropTypes } from 'react';
import findLastIndex from 'lodash/findLastIndex';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Link } from 'react-router';
import classnames from 'classnames';

export default class Announcements extends Component {
  constructor(props) {
    super(props);

    this.renderItem = this.renderItem.bind(this);
  }

  componentDidMount() {
    this.props.fetch();
  }

  renderPromoContent(item) {
    const { onDismiss } = this.props;

    return (
      <div className="row">
        <div className="columns small-3 medium-2 icon">
          <i className="fa fa-gift" />
        </div>
        <div className="columns small-12 medium-13 body">
          <h3>{ item.title }</h3>

          <div dangerouslySetInnerHTML={{ __html: item.body }} />

          { item.button_link &&
          <Link to={item.button_link} target="_blank" onClick={() => onDismiss(item)}
              className="btn btn-tertiary btn-md">
            { item.button_label }
          </Link> }
        </div>
      </div>
    );
  }

  renderSystemContent(item) {
    return (
      <div className="row">
        <div className="columns small-3 medium-2 icon">
          <i className={'fa fa-' + (item.level === 'err'? 'exclamation' : 'info')} />
        </div>
        <div className="columns small-12 medium-13 body">
          <h3>{ item.title }</h3>
          <div dangerouslySetInnerHTML={{ __html: item.body }} />
        </div>
      </div>
    );
  }

  renderItem(item, isLastShowing) {
    const { onDismiss } = this.props;

    return (
      <ReactCSSTransitionGroup key={`${item.type}_${item.id}`} transitionName="announcement-transition"
        transitionEnterTimeout={250} transitionLeaveTimeout={250}>
        { item.showing &&
        <div className={classnames("item", item.type, item.level || 'info', { hide: !isLastShowing })}>
          <button type="button" className="close" onClick={() => onDismiss(item)}>
            <i className="fa fa-times-circle" />
          </button>
          { item.type === "promo"? this.renderPromoContent(item) : this.renderSystemContent(item) }
        </div> }
      </ReactCSSTransitionGroup>
    );
  }

  render() {
    const { items } = this.props;
    const lastShowingIdx = findLastIndex(items, i => i.showing);

    if (items.length === 0) {
      return null;
    }

    return (
      <div className="announcements">
        { items.map((item, idx) => this.renderItem(item, idx === lastShowingIdx)) }
      </div>
    );
  }
}

Announcements.propTypes = {
  items: PropTypes.array.isRequired,
  fetch: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./announcements/components/index.jsx